
import { CharacterId } from '../../types';
import { Characters, DialogCharacter } from '../../validation/schema/v1/story';
import { DialogLike } from '../types';

/**
 * This migration got introduced because we need to make character ids consts (a,b,c) instead of {walletAddress}:{tokenId}
 * This enables for the character swap feature 
 */

export const migrateCharABC = async (story: DialogLike): Promise<DialogLike> => {
  // idsMapping = { [{walletAddress}:{tokenId}]: 'a' | 'b' | 'c' };
  const idsMapping = story.characters.reduce((res: Record<string, CharacterId>, cur: DialogCharacter) => {
    if (!res[cur.id]) {
      const keys = Object.keys(res);
      const id = keys.length === 0 ? 'a' : keys.length === 1 ? 'b' : 'c';
      res[cur.id] = id;
    }
    return res;
  }, {});

  let storyStr = JSON.stringify(story);

  for (const oldId of Object.keys(idsMapping)) {
    storyStr = storyStr.replace(new RegExp(oldId, 'g'), idsMapping[oldId])
  }

  const newStory = JSON.parse(storyStr);

  newStory.characters = newStory.characters.reduce((res: Characters, cur: DialogCharacter) => ({
    ...res,
    [cur.id]: cur
  }), {});

  return newStory;
};
